module.exports = __webpack_public_path__ + "static/media/addTagIcon.4a1ea466.svg";